export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13283.4e17b6f4.jpg";